import { Send, X } from "lucide-react";
import { useI18n } from "../lib/i18n";

const PROBLEM_REASONS = [
  "serviceProblemNoShow",
  "serviceProblemIncomplete",
  "serviceProblemQuality",
  "other",
];

export default function PlayerServiceActionSheet({
  subject, action, message, onMessageChange, onClose, onSubmit, busy,
}) {
  const { t } = useI18n();
  const isProblem = action === "report_problem";
  return <div className="fixed inset-0 z-[70] flex items-end justify-center" style={{ background: "rgba(0,0,0,.72)" }} data-testid="service-action-sheet">
    <section className="pc-card rounded-b-none p-5 w-full max-w-xl">
      <div className="flex items-start gap-3">
        <div><p className="text-xs uppercase tracking-[.14em]" style={{ color: "var(--pc-cyan)" }}>{t(isProblem ? "reportServiceProblem" : "requestServiceChange")}</p><h2 className="text-lg font-display font-semibold mt-1">{isProblem ? t("describeServiceProblem") : subject}</h2>{isProblem && <p className="text-xs mt-1" style={{ color: "var(--pc-muted)" }}>{subject}</p>}</div>
        <button type="button" className="pc-btn pc-btn-ghost ml-auto" style={{ padding: 8 }} onClick={onClose} aria-label={t("close")}><X size={16} /></button>
      </div>
      {isProblem && <div className="flex flex-wrap gap-2 mt-4" aria-label={t("quickReasons")}>{PROBLEM_REASONS.map((key) => <button type="button" key={key} className="pc-chip" style={{ color: message === t(key) ? "#001014" : "var(--pc-muted)", background: message === t(key) ? "var(--pc-cyan)" : "var(--pc-card-inset)" }} onClick={() => onMessageChange(t(key))}>{t(key)}</button>)}</div>}
      <label className="block text-sm mt-4"><span style={{ color: "var(--pc-muted)" }}>{t(isProblem ? "additionalDetails" : "describeServiceChange")}</span><textarea autoFocus={!isProblem} rows="4" className="pc-input mt-2" value={message} onChange={(event) => onMessageChange(event.target.value)} /></label>
      <button type="button" className="pc-btn pc-btn-primary w-full mt-4 flex items-center justify-center gap-2" disabled={busy || !message.trim()} onClick={onSubmit}><Send size={15} /> {t(isProblem ? "sendServiceProblem" : "send")}</button>
    </section>
  </div>;
}
